import React from 'react';
import { Tab } from '../../../common/sharedComponents/Tab';
import { TabContainer, FirstTabContainer } from './styled.hubTabs';

export function HubTabs ({
  template,
  selectedTab,
  selectedSubTab,
  setSelectedTab,
  setSelectedSubTab,
}) {
  function handleTabSelect (index: number) {
    setSelectedTab(index);
    setSelectedSubTab(0);
  }

  function handleSubTabSelect (indexSubTab: number) {
    setSelectedSubTab(indexSubTab);
  }

  return (
    <>
      <FirstTabContainer>
        {template &&
          template.map((tab, index) => (
            <Tab
              key={index}
              title={tab.tabName}
              isSelected={Number(selectedTab) === index}
              onClick={() => handleTabSelect(index)}
            />
          ))}
      </FirstTabContainer>
      <TabContainer>
        {template &&
          template[selectedTab].subTabs &&
          template[selectedTab].subTabs.map((subTabs, index) => (
            <Tab
              key={index}
              title={subTabs.subTabName}
              isSelected={Number(selectedSubTab) === index}
              onClick={() => handleSubTabSelect(index)}
            />
          ))}
      </TabContainer>
    </>
  );
}
